import {
  Axios,
  type AxiosRequestConfig
} from "../modules/axios";

export const $httpAdmin = Axios.create();

export const $httpAdminSync = Axios.create();

export function configureHttp({ adapter }: Partial<AxiosRequestConfig> = {}) {
  if (adapter) Axios.defaults.adapter = adapter;

  Axios.defaults.timeout = 1000 * 60 * 5;
  Axios.defaults.validateStatus = function (status) {
    return status < 400;
  };

  return Axios;
}
